<script>
import Switch from 'element-ui/lib/switch';

export default Switch;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/switch.css';
@import '../../stylesheets/utils/utils';

.el-switch__label--right {
  @include rtl() {
    margin-right: 10px;
    margin-left: 0;
  }
}
</style>
